import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './PatientStep.scss';

export type Submenu = {
    id: string;
    label: string;
    url: string;
};

type Props = {
    index: number;
    label: string;
    onClick: () => void;
    isDisabled?: boolean;
    isActive?: boolean;
    submenuItems: Submenu[];
    onSubmenuItemClick: (item: Submenu) => void;
};

const PatientStep: React.FC<Props> = ({
    index,
    label,
    onClick,
    isDisabled,
    isActive,
    submenuItems,
    onSubmenuItemClick,
}) => {
    const location = useLocation();
    const [ hovered, setHovered ] = useState(false);

    return (
        <div
            className={`patient-step ${isDisabled ? 'disabled' : ''} ${!isDisabled && isActive ? 'active' : ''}`}
            onClick={() => {
                if (isDisabled) {
                    return;
                }

                onClick();
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div>{index}.</div>
            <div className="patient-step_labelContainer">
                <span className="patient-step_label">{label}</span>
                {submenuItems.length > 0 && (
                    <span className="patient-step_triangle">▼</span>
                )}
                {!isDisabled && hovered && submenuItems.length > 0 && (
                    <div className="patient-step_submenus">
                        {submenuItems.map((item) => {
                            const isSubmenuActive = location.pathname.startsWith(item.url);

                            return (
                                <div
                                    key={item.id}
                                    className={`patient-step_submenus_item ${isSubmenuActive ? 'active' : ''}`}
                                    onClick={() => {
                                        onSubmenuItemClick(item);
                                        setHovered(false);
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                >
                                    {item.label}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PatientStep;